export var ModalComponent;
(function (ModalComponent) {
    ModalComponent["NavigationAppSelection"] = "NavigationAppSelection";
    ModalComponent["LocationNotFound"] = "LocationNotFound";
})(ModalComponent || (ModalComponent = {}));
